/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FormDraftFieldOptionPayload } from './FormDraftFieldOptionPayload';
export type FormDraftFieldPayload = {
    type: FormDraftFieldPayload.type;
    clientField?: FormDraftFieldPayload.clientField | null;
    clientId: string;
    label: string;
    content: string;
    required: boolean;
    sortOrder: number;
    options: Array<FormDraftFieldOptionPayload>;
    overwriteClientData?: boolean;
};
export namespace FormDraftFieldPayload {
    export enum type {
        TEXT = 'text',
        TEXTAREA = 'textarea',
        NUMBER = 'number',
        FILE = 'file',
        SINGLE_CHOICE = 'single_choice',
        MULTIPLE_CHOICE = 'multiple_choice',
        INFO = 'info',
    }
    export enum clientField {
        FIRST_NAME = 'first_name',
        LAST_NAME = 'last_name',
        GENDER = 'gender',
        BIRTHDATE = 'birthdate',
        EMAIL = 'email',
        PHONE = 'phone',
        STREET = 'street',
        ADDITIONAL_INFORMATION = 'additional_information',
        ZIP = 'zip',
        FILE = 'file',
    }
}

